"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Spinner = exports.SpinnerAlignment = void 0;
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var Spinner_styles_1 = require("./Spinner.styles");
var core_1 = require("@material-ui/core");
var enums_1 = require("../../enums");
var SpinnerAlignment;
(function (SpinnerAlignment) {
    SpinnerAlignment["Centered"] = "centered";
})(SpinnerAlignment = exports.SpinnerAlignment || (exports.SpinnerAlignment = {}));
var Spinner = function (_a) {
    var alignment = _a.alignment, _b = _a.name, name = _b === void 0 ? 'spinner' : _b;
    var classes = (0, Spinner_styles_1.useSpinnerStyles)();
    return !alignment ? (React.createElement(core_1.CircularProgress, { "data-signa": name, variant: 'indeterminate', color: enums_1.Color.primary })) : (React.createElement("div", { className: classes[alignment], "data-signa": "".concat(name, "-container") },
        React.createElement(core_1.CircularProgress, { variant: 'indeterminate', color: enums_1.Color.primary })));
};
exports.Spinner = Spinner;
